import { useState } from 'react'
import { usePage } from '@inertiajs/react'
import type { PageProps } from '@/types'

const CHATBOT_URLS: Record<string, string> = {
  medecins: 'https://iframe-chat-medecin-frontend-267518984853.europe-west1.run.app/chat.html',
  patients: 'https://iframe-chat-patient-frontend-267518984853.europe-west1.run.app/chat.html',
  pharmaciens: 'https://iframe-chat-pharmacie-frontend-267518984853.europe-west1.run.app/chat.html',
}

export function ChatbotWidget() {
  const { community, auth } = usePage<PageProps>().props
  const [isOpen, setIsOpen] = useState(false)

  const slug = community?.slug
  if (!slug || !CHATBOT_URLS[slug]) return null

  const baseUrl = CHATBOT_URLS[slug]
  const params = new URLSearchParams()
  if (auth?.user?.email) params.set('email', auth.user.email)
  if (auth?.user?.name) params.set('name', auth.user.name)
  const iframeSrc = params.toString() ? `${baseUrl}?${params}` : baseUrl

  return (
    <div className="fixed bottom-6 right-6 z-50">
      {isOpen && (
        <div className="mb-4 w-[400px] h-[600px] rounded-2xl shadow-2xl overflow-hidden bg-white border border-gray-200">
          <div className="flex items-center justify-between px-4 py-3 bg-tessan-green text-white">
            <span className="font-semibold text-sm">Assistant Tessan</span>
            <button
              onClick={() => setIsOpen(false)}
              className="text-white/80 hover:text-white transition-colors"
              aria-label="Fermer le chatbot"
            >
              <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                <path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd" />
              </svg>
            </button>
          </div>
          <iframe
            src={iframeSrc}
            className="w-full h-[calc(100%-48px)]"
            title="Chatbot Tessan"
            allow="microphone"
          />
        </div>
      )}

      {!isOpen && (
        <button
          onClick={() => setIsOpen(true)}
          className="w-14 h-14 rounded-full bg-tessan-green text-white shadow-lg hover:shadow-xl hover:scale-105 transition-all flex items-center justify-center"
          aria-label="Ouvrir le chatbot"
        >
          <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
            <path strokeLinecap="round" strokeLinejoin="round" d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z" />
          </svg>
        </button>
      )}
    </div>
  )
}
